export const validationErrorType = {
  valid: 1,
  empty: 2,
  wrong: 3,
  outOfLimit: 4,
};
